type ResolveCsvExportSelectionScopeArgs = {
    pickedIds: string[];
    selectionSessionId: string;
};

export type CsvExportSelectionScope = {
    uniquePickedIds: string[];
    selectedIds: string[] | undefined;
    selectionSessionId: string | undefined;
};

export const dedupeCsvExportIds = (ids: string[]): string[] => [...new Set(ids)];

export const resolveCsvExportSelectionScope = ({
    pickedIds,
    selectionSessionId,
}: ResolveCsvExportSelectionScopeArgs): CsvExportSelectionScope => {
    const uniquePickedIds = dedupeCsvExportIds(pickedIds);

    return {
        uniquePickedIds,
        selectedIds: uniquePickedIds.length && !selectionSessionId ? uniquePickedIds : undefined,
        selectionSessionId: uniquePickedIds.length && selectionSessionId ? selectionSessionId : undefined,
    };
};
